import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import DashboardSidebar from '../DashboardComponents/DashboardSidebar';
// import './DashboardLayout.css';

const DashboardLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
      if (window.innerWidth >= 992) {
        setSidebarOpen(true);
      } else {
        setSidebarOpen(false);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(prev => !prev);
  };

  return (
    <div className="dashboard-container">
      <Header onMenuClick={toggleSidebar} isDashboard={true} />
      
      {/* Toggle button added below the Header component */}
      <button 
        className={`sidebar-toggle-btn ${sidebarOpen ? 'show' : '111'}` }
        onClick={toggleSidebar}
      >
        <i className={`far ${sidebarOpen ? 'fa-arrow-alt-circle-left' : 'fa-arrow-alt-circle-right'}`}></i>
      </button>
      <button 
        className={`sidebar-toggle-btn ${sidebarOpen ? 'show' : '111'}` }
        onClick={toggleSidebar}
      >
        <i className={`far ${sidebarOpen ? 'fa-arrow-alt-circle-left' : 'fa-arrow-alt-circle-right'}`}></i>
      </button>
      <div className="dashboard-content-wrapper">
      
        <DashboardSidebar isOpen={sidebarOpen} isMobile={isMobile} onClose={() => setSidebarOpen(false)} />
        
        <main className={`dashboard-main-content ${sidebarOpen ? 'sidebar-open' : ''}`}>
          <div className="content-inner">
          <div className='bubble bubble-1'></div>
  <div className='bubble bubble-2'></div>
  <div className='bubble bubble-3'></div>
  <div className='bubble bubble-4'></div>
  <div className='bubble bubble-5'></div>
  <div className='bubble bubble-6'></div>
  <div className='bubble bubble-7'></div>
  <div className='bubble bubble-8'></div>
  <div className='bubble bubble-9'></div>
  <div className='bubble bubble-10'></div>
  <div className='bubble bubble-11'></div>
  <div className='bubble bubble-12'></div>
  <div className='bubble bubble-13'></div>
  <div className='bubble bubble-14'></div>
  <div className='bubble bubble-15'></div>
  <div className='bubble bubble-16'></div>
  <div className='bubble bubble-17'></div>
  <div className='bubble bubble-18'></div>
  <div className='bubble bubble-19'></div>
  <div className='bubble bubble-20'></div>
  <div className='bubble bubble-21'></div>
  <div className='bubble bubble-22'></div>
  <div className='bubble bubble-23'></div>
  <div className='bubble bubble-24'></div>
  <div className='bubble bubble-25'></div>
  <div className='bubble bubble-26'></div>
  <div className='bubble bubble-27'></div>
  <div className='bubble bubble-28'></div>
  <div className='bubble bubble-29'></div>
  <div className='bubble bubble-30'></div>
            <Outlet /> 
            {children}
          </div>
        </main>
      </div>
      <div className='dashboard-ftr-wrap'>
      <Footer />
      </div>
    </div>
  );
};

export default DashboardLayout;